import { useState } from "react"
import { Confirm } from "./Confirm"

type Props = {
  Trigger: JSX.ElementType
  onConfirm?: (comment?: string) => Promise<unknown>
  commentRequired?: boolean
}

export const ConfirmDelete = ({ Trigger, onConfirm, commentRequired }: Props) => {
  const [comment, setComment] = useState("")
  const [error, setError] = useState(false)

  const handleConfirm = async () => {
    if (commentRequired && !comment.trim()) {
      setError(true)
      throw new Error("comment required")
    }
    if (onConfirm) {
      await onConfirm(comment)
      setComment("")
      setError(false)
    }
  }

  return (
    <Confirm Trigger={Trigger} onConfirm={handleConfirm}>
      <h3>Dzēst</h3>
      <p>Vai tiešām vēlieties dzēst?</p>
      <textarea
        value={comment}
        onChange={(e) => {
          setComment(e.target.value)
          if (error) setError(false)
        }}
        placeholder={commentRequired ? "Iemesls" : "Iemesls (neobligāts)"}
        style={{
          width: "100%",
          minHeight: 60,
          marginTop: 8,
          padding: 8,
          borderRadius: 8,
          border: error ? "1px solid #e53e3e" : "1px solid #ccc",
          resize: "vertical",
          fontFamily: "inherit",
          fontSize: 14,
        }}
      />
      {error && (
        <span style={{ color: "#e53e3e", fontSize: 13, marginTop: 4, display: "block" }}>
          Lūdzu norādiet iemeslu
        </span>
      )}
    </Confirm>
  )
}
